import {
  GET_ISSUES_LIST_SUCCESS,
  GET_ISSUES_LIST_BY_ID_SUCCESS,
  SET_PROJECT_ID,

  ISSUES_PDF_REQUEST,
  ISSUES_PDF_SUCCESS,
  SUBSCRIBE_TO_ISSUE, CLEAR_AND_UNSUBSCRIBE_FROM_ISSUES
} from './actions';
import {
  SIGN_OUT
} from '../auth/actions';

const initialState = {
  list: {},
  listById: {},
  selectedProjectId: false,

  pdfLoading: false,
  issuesList: {},
};

export default function issueReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ISSUES_LIST_SUCCESS: {
      return {
        ...state,
        list: action.payload
      }
    }
    case GET_ISSUES_LIST_BY_ID_SUCCESS: {
      return {
        ...state,
        listById: action.payload
      }
    }
    case SET_PROJECT_ID: {
      return {...state, selectedProjectId: action.payload.projectId};
    }
    case SIGN_OUT: {
      return {
        ...initialState
      }
    }
    case ISSUES_PDF_REQUEST: {
      return { ...state, pdfLoading: true}
    }
    case ISSUES_PDF_SUCCESS: {
      return { ...state, pdfLoading: false}
    }

    case SUBSCRIBE_TO_ISSUE: {
      const { issue, issueIds } = action.payload;
      const issuesList = { ...state.issuesList };

      Object.keys(issuesList).forEach(issueId => {
        if (!issueIds.includes(issueId)) {
          delete issuesList[issueId];
        }
      })

      issuesList[issue.id] = issue;

      return { ...state, issuesList }
    }

    case CLEAR_AND_UNSUBSCRIBE_FROM_ISSUES: {
      return { ...state, issuesList: {} }
    }

    default: {
      return {...state};
    }
  }
}
